import { useState, useEffect } from 'react';
import { Table, Button, Tag, Input, Pagination, Popconfirm, message } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Https from '@/https';
import './Company.css'

export default function Company() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [messageApi, messageContextHolder] = message.useMessage();
  const [name, setName] = useState('');
  const [toggleReset, setToggleReset] = useState(false);
  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  }
  const [contactName, setContactName] = useState('');
  const onContactNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactName(e.target.value);
  }

  const [contactPhone, setContactPhone] = useState('');
  const onContactPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactPhone(e.target.value);
  }

  const reset = () => {
    setName('');
    setContactName('');
    setContactPhone('');
    setPageIndex(1);
    setToggleReset(true);
  }

  const search = () => {
    setPageIndex(1);
    getCompanyList();
  }

  const handleCompanyCreate = () => {
    navigate(`/main/company/create`);
    dispatch({
      type: 'PUSH_MENU_KEYPATH',
      payload: {
        selectedKeys: 'companyCreate',
        keyPath: '添加公司',
      }
    })
  }

  let [pageIndex, setPageIndex] = useState(1);
  let [pageSize, setPageSize] = useState(10);
  let [total, setTotal] = useState(0);
  const [companyList, setCompanyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const companyColumns = [
    {
      title: '公司名称',
      dataIndex: 'name',
      key: 'name',
      width: 180,
    },
    {
      title: '管理员账号',
      dataIndex: 'account',
      key: 'account',
    },
    {
      title: '公司类型',
      dataIndex: 'type',
      key: 'type',
      render: (type: any) => {
        return (
          type === 1 ? <Tag color="purple">分公司</Tag> : (
            type === 2 ? <Tag color="green">合伙人</Tag> :
            <Tag color="cyan">公司</Tag>
          )
        )
      }
    },
    {
      title: '联系人',
      dataIndex: 'contactName',
      key: 'contactName'
    },
    {
      title: '联系电话',
      dataIndex: 'contactPhone',
      key: 'contactPhone',
      width: 180
    },
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
      width: 250,
      render: (address: any, record: any) => {
        return (
          <span>{record.provinceNam}{record.cityName}{record.regionName}{record.address}</span>
        )
      }
    },
    {
      title: '是否有效',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: any) => {
        return (
          isActive === 1 ? <Tag color="green">是</Tag> : <Tag color="red">否</Tag>
        )
      }
    },
    {
      title: '开始时间',
      dataIndex: 'beginTime',
      key: 'beginTime',
      width: 180
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      key: 'endTime',
      width: 180
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: 180
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right' as const,
      render: (_: any, record: any) => {
        return (
          <>
            <Button color="primary" variant="link" size="small" onClick={() => handleCompanyView(record)}>详情</Button>
            <Button color="cyan" variant="link" size="small" onClick={() => handleCompanyEdit(record)}>编辑</Button>
            <Popconfirm
              title="提示"
              description="确定重置密码?"
              onConfirm={() => handleResetPwd(record)}
              okText="确定"
              cancelText="取消">
              <Button color="danger" variant="link" size="small">重置密码</Button>
            </Popconfirm>
            {
              record.isActive === 1 ?
              <Popconfirm
                title="提示"
                description="确定禁用公司?"
                onConfirm={() => handleEnableCompany(record)}
                okText="确定"
                cancelText="取消">
                <Button color="gold" variant="link" size="small">禁用</Button>
              </Popconfirm> :
              <Popconfirm
                title="提示"
                description="确定启用公司?"
                onConfirm={() => handleEnableCompany(record)}
                okText="确定"
                cancelText="取消">
                <Button color="green" variant="link" size="small">启用</Button>
              </Popconfirm>
            }
          </>
        )
      }
    }
  ]

  const handleCompanyView = (record: any) => {
    navigate(`/main/company/detail`, { state: { companyInfo: record } });
    dispatch({
      type: 'PUSH_MENU_KEYPATH',
      payload: {
        selectedKeys: 'companyDetail',
        keyPath: '公司详情',
      }
    })
  }

  const handleCompanyEdit = (record: any) => {
    navigate(`/main/company/edit`, { state: { companyInfo: record } });
    dispatch({
      type: 'PUSH_MENU_KEYPATH',
      payload: {
        selectedKeys: 'companyEdit',
        keyPath: '编辑公司',
      }
    })
  }

  const handleResetPwd = (record: any) => {
    Https.post({
      url: 'Api/URPM/V1/User/ResetPassword',
      data: {
        userId: record.userId
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('操作成功');
        getCompanyList();
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }

  const handleEnableCompany = (record: any) => {
    Https.post({
      url: 'Api/Tenant/V1/tenant/EnOrDisTenant',
      data: {
        ids: [record.id],
        isActive: record.isActive === 1 ? 0 : 1
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('操作成功');
        getCompanyList();
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }

  const getCompanyList = () => {
    setLoading(true);
    Https.post({
      url: 'Api/Tenant/V1/tenant/list',
      data: {
        pageIndex,
        pageSize,
        name,
        contactName,
        contactPhone
      }
    }).then(res => {
      if(res.state === 1) {
        setCompanyList(res.data.tenantList);
        setTotal(res.data.totalCount);
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    }).finally(() => {
      setLoading(false);
    })
  }

  useEffect(() => {
    getCompanyList();
  }, [])

  useEffect(() => {
    if(toggleReset) {
      getCompanyList();
      setToggleReset(false);
    }
  }, [toggleReset])

  useEffect(() => {
    getCompanyList();
  }, [pageIndex, pageSize])

  return (
    <section className="Company">
      <section className="search-box">
        <section className="search-item">
          <span className="search-label">公司名称</span>
          <Input placeholder="请输入公司名称" value={name} allowClear onChange={onNameChange} />
        </section>
        <section className="search-item">
          <span className="search-label">联系人</span>
          <Input placeholder="请输入联系人" value={contactName} allowClear onChange={onContactNameChange} />
        </section>
        <section className="search-item">
          <span className="search-label">联系电话</span>
          <Input placeholder="请输入联系人" value={contactPhone} allowClear onChange={onContactPhoneChange} />
        </section>
      </section>
      <section className="search-btns">
        <Button onClick={reset}>重置</Button>
        <Button type="primary" onClick={search}>查询</Button>
        <Button type="primary" onClick={handleCompanyCreate} icon={<PlusSquareOutlined />} style={{marginLeft: '10px'}}>添加公司</Button>
      </section>
      <section>
        <Table
          dataSource={companyList}
          rowKey="id"
          columns={companyColumns}
          pagination={false}
          scroll={{x: 'max-content', y: 'calc(100vh - 350px)'}}
          loading={loading}
         />
      </section>
      <section className="page-box">
        <Pagination
          align="end"
          total={total}
          showTotal={(total) => `共 ${total} 条`}
          current={pageIndex}
          defaultPageSize={10}
          defaultCurrent={1}
          onChange={(page, pageSize) => {
            setPageIndex(page);
            setPageSize(pageSize);
          }}
        />
      </section>
      { messageContextHolder }
    </section>
  )
}